import { Link } from "react-router-dom";
import { ArrowRight, HeartPulse, Umbrella } from "lucide-react";
import { useInsurers } from "@/lib/format";
import { useLead } from "@/components/layout/Layout";

export const CsrBar = ({ x, min = 80 }) => {
  const openLead = useLead();
  const w = Math.max(4, ((x.csr - min) / (100 - min)) * 100);
  return (
    <div data-testid={`insurer-bar-${x.id}`} className="group">
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="font-semibold text-slate-900 truncate">{x.name}</span>
        <span className="flex items-center gap-3 shrink-0">
          <span className="font-mono font-bold">{x.csr.toFixed(2)}%</span>
          <button data-testid={`insurer-quote-${x.id}`} onClick={() => openLead({ id: x.id, company_name: x.name })} className="text-xs font-bold text-[#059669] hover:underline">Get Quote</button>
        </span>
      </div>
      <div className="mt-1.5 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full bg-gradient-to-r from-amber-400 to-[#10B981] transition-[width] duration-700" style={{ width: `${w}%` }} /></div>
    </div>
  );
};

export const InsuranceSnapshot = () => {
  const { data } = useInsurers();
  const items = data?.items || [];
  const life = items.filter((x) => x.type === "life").slice(0, 6);
  const health = items.filter((x) => x.type === "health").slice(0, 6);
  return (
    <section data-testid="insurance-snapshot" className="bg-[#F1F5F9] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Insurance</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">Who actually pays claims?</h2>
          </div>
          <Link to="/insurance" data-testid="insurance-view-all" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#059669]">All insurers <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {[["Life insurers · Claim settlement ratio", life, Umbrella, 95], ["Health insurers · Claim settlement ratio", health, HeartPulse, 80]].map(([t, list, I, min]) => (
            <div key={t} className="bg-white rounded-2xl border border-slate-200 p-6">
              <p className="flex items-center gap-2 font-display font-bold text-lg"><I className="w-5 h-5 text-amber-500" />{t}</p>
              <div className="mt-6 space-y-5">{list.map((x) => <CsrBar key={x.id} x={x} min={min} />)}</div>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-500 mt-4">{data?.note}</p>
      </div>
    </section>
  );
};
